const theme = {
    dark: "#4d4d4d",
    light: "#f2f2f2",
    highlight: "#d45500",
    background: "#ffffff",
    titleFont: {
        "fontFamily": "Nunito Sans, sans-serif",
        "fontWeight": "200",
        "textTransform": "uppercase"
    },
    bodyFont: {
        "fontFamily": "Nunito Sans, sans-serif",
        "fontWeight": "200"
    },
    header: {
        height: "100px",
        flatHeight: "58px"
    }
}
export default theme